// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"445":"bb88958c","659":"7661fac7"}[chunkId] + ".css";
};